import React from "react";
import aboutBanner from '../../assets/img/safariformbanner.jpg'
function AboutBanner() {
  return (
    <>
      <section className="banner_section-inner position-relative">
        <picture className="position-relative">
          <source
            srcSet="/assets/dd598883/img/safariformbanner.jpg"
            media="(max-width:576px)"
            type="image/webp"
          />
          <img
            src={aboutBanner}
            className="d-block w-100 "
            alt="banner"
          />
        </picture>
      </section>
    </>
  );
}

export default AboutBanner;
